module.exports = __webpack_public_path__ + "img/32.3b432274.png";